var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5153,
    cy: 13.9996,
    r: 13.4996,
    stroke: "#6C584C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_2661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6073 10.3459L14.9796 8.97355C15.2799 8.67319 15.6365 8.43494 16.0289 8.27238C16.4214 8.10983 16.842 8.02617 17.2668 8.02617C17.6915 8.02617 18.1121 8.10983 18.5046 8.27238C18.897 8.43494 19.2536 8.67319 19.554 8.97355C19.8543 9.27391 20.0926 9.63049 20.2551 10.0229C20.4177 10.4154 20.5013 10.836 20.5013 11.2607C20.5013 11.6855 20.4177 12.1061 20.2551 12.4986C20.0926 12.891 19.8543 13.2476 19.554 13.5479L18.1816 14.9202M15.437 17.6649L14.0647 19.0372C13.7643 19.3375 13.4078 19.5758 13.0153 19.7384C12.6229 19.9009 12.2023 19.9846 11.7775 19.9846C10.9196 19.9846 10.0969 19.6438 9.49032 19.0372C8.88372 18.4306 8.54293 17.6079 8.54293 16.75C8.54293 15.8921 8.88371 15.0694 9.49032 14.4628L10.8626 13.0905",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 15.8359L16.347 12.1764",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.526,
    height: 15.526,
    fill: "white",
    transform: "translate(3.53906 14) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIc);
export default __webpack_public_path__ + "static/media/copy_ic.539b457e2d83f0c94a7eec283410c8bc.svg";
export { ForwardRef as ReactComponent };